import { owcTheme } from 'core/theme/theme.config';
import { PocInput, PocList, PocSelectDropdown } from 'commons/components/components-wrapper';
import styled from 'styled-components';

export const SearchableDropdownLayout = styled.div`
    owc-typography.label {
        color: var(--one-color-interaction-default-intensity-medium);

        &.block {
            padding-bottom: 8px;
        }
    }

    &.inline {
        display: flex;
        align-items: center;
        justify-content: space-between;
    }
`;

export const SearchableDropdownWrapper = styled.div`
    position: relative;
`;

export const SearchableOwcList = styled(PocList)`
    max-height: 168px;
    overflow: auto;

    &[data-virtualization='true'] {
        height: 168px;
    }
`;

export const SearchableDropdownComponent = styled(PocSelectDropdown)<{ minWidth?: string }>`
    owc-popover {
        min-width: ${({ minWidth }) => minWidth || 'inherit'};
    }

    /* OWC-OVERRIDE: keep the menu visible while results load so the search field does not
       flicker; owc hides the whole menu in its loading state and offers no prop to keep it
       mounted in v7.6.0. */
    .owc-menu.owc-menu--loading {
        visibility: unset;
    }

    /* OWC-OVERRIDE: the dropdown's own list owns the scrolling (SearchableOwcList caps it at
       168px); release the card wrapper's and list's height clamps so there is exactly one
       scroll container. owc-select-dropdown exposes no popover-height prop in v7.6.0, and
       !important is needed to beat owc's max-height on the inner list. Revisit on the next @one upgrade. */
    owc-popover .owc-card .owc-card__content-wrapper {
        overflow: unset;

        > .owc-list:first-child {
            max-height: unset !important;
            overflow: unset;
        }
    }

    owc-menu {
        owc-popover {
            overflow: visible;
        }
    }

    owc-list {
        /* OWC-OVERRIDE: nested option groups render flush; owc pads the children slot and
           exposes no indentation/padding prop in v7.6.0. The .hidden rule targets our own
           class on the owc element (client-side filtering). */
        .owc-list-item > [slot='children'] {
            padding: 0;
        }

        .owc-list-item.hidden {
            display: none;
        }

        owc-list-item > owc-tooltip {
            word-break: break-all;
        }

        .footer {
            bottom: 0;
            z-index: 7;
            display: flex;
            align-items: center;
            justify-content: space-between;
            width: 100%;
            padding: 10px;
            background-color: #fff;
            border-top: 0.0625rem solid var(--one-color-background-contrast);

            owc-button {
                overflow: hidden;
                white-space: break-spaces;
            }
        }
    }
`;

export const SearchBarLayout = styled.div`
    z-index: 7;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 99%;
    padding: 10px 15px;
    background-color: #fff;
`;

export const SearchableDropdownInput = styled(PocInput)`
    /* v7 owc-input host has a fixed default width (~250px); && raises specificity to fill the search bar (v6 was full-width). */
    && {
        width: 100%;
    }

    cursor: text !important; /* not possible to override therefore !important is used */
    background-color: unset !important;
`;

export const LoadingContainer = styled.div`
    display: flex;
    flex-flow: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 96px;
`;

export const OptionLabel = styled.div`
    display: flex;
    gap: ${owcTheme['one-spacing-gap-xs']};
    align-items: center;
    min-width: 0;

    /* Only the label shrinks, so its marker stays readable after the ellipsis. */
    > :first-child {
        flex: 0 1 auto;
        min-width: 0;
    }
`;

export const OptionMarker = styled.span`
    flex: none;
`;
